export default __webpack_public_path__ + "static/media/More Vertical.9e2867b1.svg";